import { render, staticRenderFns } from "./ActiveGoodsCard.vue?vue&type=template&id=0244749f"
import script from "./ActiveGoodsCard.vue?vue&type=script&lang=js"
export * from "./ActiveGoodsCard.vue?vue&type=script&lang=js"
import style0 from "./ActiveGoodsCard.vue?vue&type=style&index=0&id=0244749f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports